export default function createBulkpackagesEditErrors(errors) {
  return {
    isEnabled: errors?.is_enabled || [],
    isArchived: errors?.is_archived || [],
    discountPercent: errors?.discount_percent || [],
  };
}
